// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__J84XG","logo":"styles_logo__2CjTu","header-content":"styles_header-content__27CLt"};